/* ==========================================================================
   MICHELANGELO MUSIC — Instagram feed watchdog
   Added 2026-07-25.

   Instafeed is a third-party global ScriptTag loaded from nfcube.com. When it
   works it paints tiles into #insta-feed. When it does not — an expired
   Instagram token, a lapsed subscription, a content blocker, or simply the
   CDN being slow — it paints nothing, and the section used to leave a silent
   hole in the middle of the homepage with a heading pointing at it.

   This watches the mount point and, if no media has appeared by the time the
   checks run out, swaps in a small self-contained card instead. A visitor
   then sees a deliberate link to the profile rather than an empty band, and
   the page never looks broken because someone else's script had a bad day.

   Checks are staged rather than a single timeout because the app often
   resolves late on a cold cache; giving up at 3s would swap out a feed that
   was about to arrive.
   ========================================================================== */

(function () {
  'use strict';

  var CHECKS = [2500, 5000, 9000];

  function init(section) {
    var feed = section.querySelector('[data-mm-igfeed]');
    var fallback = section.querySelector('[data-mm-igfallback]');
    if (!feed || !fallback) return;

    var mount = feed.querySelector('#insta-feed');
    if (!mount) return;

    var settled = false;

    /* The app renders <img>, and for reels a <video>. Either counts. Checking
       for child nodes alone is not enough — it drops in an empty container
       first and fills it afterwards. */
    function hasMedia() {
      return !!mount.querySelector('img, video');
    }

    function succeed() {
      if (settled) return;
      settled = true;
      if (observer) observer.disconnect();
    }

    function giveUp() {
      if (settled) return;
      settled = true;
      if (observer) observer.disconnect();
      feed.hidden = true;
      fallback.hidden = false;
    }

    var observer = null;
    if ('MutationObserver' in window) {
      observer = new MutationObserver(function () {
        if (hasMedia()) succeed();
      });
      observer.observe(mount, { childList: true, subtree: true });
    }

    CHECKS.forEach(function (delay, i) {
      setTimeout(function () {
        if (settled) return;
        if (hasMedia()) succeed();
        else if (i === CHECKS.length - 1) giveUp();
      }, delay);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mm-ig]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
